import { environment as pre } from './environment.pre';

export const environment = {
  ...pre,
  assetsUrl: 'https://pre-webs.yulava.com/',
};
